import { SyntheticEvent } from "react";

import { hasClassPrefix } from "../../utils";

interface ButtonProps {
  label: string;
  onClick?: (e: SyntheticEvent) => void;
  disabled: boolean;
  styleVal?: string;
  type: "button" | "submit";
  customWidth?: string;
  customFontColor?: string;
  Icon?: JSX.Element;
}

const Button: React.FC<ButtonProps> = ({
  type,
  label,
  onClick,
  disabled = false,
  styleVal = "",
  customWidth,
  customFontColor,
  Icon,
}) => {
  return (
    <button
      type={type}
      className={[
        "flex space-x-2.5 items-center justify-center rounded-lg",
        hasClassPrefix(styleVal, "p-") ? "" : "px-5 py-2",
        customWidth || "w-fit",
        disabled ? "bg-[#211551]/20" : "bg-[#211551]",
        customFontColor || "text-white",
        styleVal || "",
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={onClick}
      disabled={disabled}
    >
      {Icon}
      <span>{label}</span>
    </button>
  );
};

export default Button;
